import cn from 'classnames'
import styles from './timespan-toggle.module.scss'

const LABELS = {
    '7d':   '7d',
    '30d':  '30d',
    '90d':  '90d',
    '365d': '1y'
}

/**
 * @param {{
 *   value: string,
 *   options: string[],
 *   onChange: (value: string) => void
 * }} props
 */
export function TimespanToggle({value, options, onChange}) {
    return (
        <div className={styles.group} role="radiogroup" aria-label="Time range">
            {options.map(option => {
                const active = option === value
                return (
                    <button
                        key={option}
                        type="button"
                        role="radio"
                        aria-checked={active}
                        className={cn(styles.cell, {[styles.active]: active})}
                        onClick={() => onChange(option)}
                    >
                        {LABELS[option] ?? option}
                    </button>
                )
            })}
        </div>
    )
}
